export default "__VITE_ASSET__KIyPnVLH__"